import { useState } from "react";
import { faqItems } from "@/mocks/updiag";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-[#F8FAFC] py-24">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-blue-50 text-[#0F3B5F] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            FAQ
          </span>
          <h2 className="text-4xl font-extrabold text-[#0F3B5F] mb-4" style={{ fontFamily: "Barlow, sans-serif" }}>
            Questions fréquentes
          </h2>
          <p className="text-gray-500">Tout ce que vous devez savoir sur les diagnostics immobiliers à Paris et en IDF.</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className={`bg-white rounded-2xl border transition-all duration-300 overflow-hidden ${open === i ? "border-[#F97316]" : "border-gray-100"}`}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className={`font-semibold text-sm pr-4 ${open === i ? "text-[#F97316]" : "text-[#0F3B5F]"}`}>{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl flex-shrink-0 transition-transform duration-300 ${open === i ? "rotate-180 text-[#F97316]" : "text-gray-400"}`}></i>
              </button>
              {open === i && (
                <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-50 pt-4">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
